import * as rootNavigation from "./rootNavigation";

export { default as RouteKeys } from "./RouteKeys";
export { default as linkingConfig } from "./config/linking";

export { navigationRef } from "./rootNavigation";
export { rootNavigation };
